// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1a7e3","row":"Node_row__1blL8","label":"Node_label__2LYC7","footer":"Node_footer__2nLEY"};